<template>
  <div class="relative">
    <!-- Navbar horizontale -->
    <nav class="w-full max-w-screen bg-white flex justify-between items-center h-16 shadow-md  md:hidden px-8">
      
      <!-- Menu Drawer -->
      <button @click="toggleDrawer" class="flex flex-col items-center justify-center focus:outline-none">
        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
        <span class="text-xs mt-1">Menu</span>
      </button>

      <img class="w-36" src="https://datafuse.fr/img/logo.068b0009.svg">

      <!-- Notifications -->
     <NotificationsView />
    </nav>

    <!-- Drawer / Volet -->
    <transition name="slide">
      <aside v-if="isDrawerOpen" class="fixed inset-0 z-40 flex">
        <div class="fixed inset-0 bg-black bg-opacity-30" @click="toggleDrawer"></div>
        <div class="relative w-64 bg-white h-full shadow-lg flex flex-col overflow-y-auto pb-12">
          <div class="p-4 flex justify-between items-center border-b border-gray-200">
 <div class="flex items-center gap-3">
        <img src="@/assets/LOGO__Datafuse.svg" class="h-10 rounded-lg" alt="Logo Datafuse" />
        <span v-if="!isCollapsed" class="font-semibold tracking-wide">DATAFUSE</span>
      </div>
            <button @click="toggleDrawer" class="text-gray-600 hover:text-gray-900">
              ✕
            </button>
          </div>

    <!-- Navigation -->
    <nav class="flex-1 px-2 py-6 space-y-6">
      <!-- Section: Général -->
      <div>
        <h3 v-if="!isCollapsed" class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">
          Général
        </h3>
        <div class="space-y-1">
          <RouterLink
            v-for="item in generalMenu"
            :key="item.label"
            :to="item.to"
            class="flex items-center gap-3 rounded-lg text-sm px-4 py-2"
            :class="themeClasses.link"
            :active-class="themeClasses.active"
          >
            <component :is="item.icon" class="w-5 h-5 text-current" />
            <span v-if="!isCollapsed">{{ item.label }}</span>
          </RouterLink>
        </div>
      </div>

      <!-- Section: Communication -->
      <div>
        <h3 v-if="!isCollapsed" class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">
          Communication
        </h3>
        <div class="space-y-1">
          <RouterLink
            v-for="item in commMenu"
            :key="item.label"
            :to="item.to"
            class="flex items-center gap-3 rounded-lg text-sm px-4 py-2 relative"
            :class="themeClasses.link"
            :active-class="themeClasses.active"
          >
            <component :is="item.icon" class="w-5 h-5 text-current" />
            <span v-if="!isCollapsed">{{ item.label }}</span>
          </RouterLink>
        </div>
      </div>

      <!-- Section: Paramètres -->
      <div>
        <h3 v-if="!isCollapsed" class="text-xs font-semibold uppercase tracking-wider text-gray-400 mb-2">
          Paramètres
        </h3>
        <div class="space-y-1">
          <RouterLink
            v-for="item in settingsMenu"
            :key="item.label"
            :to="item.to"
            class="flex items-center gap-3 rounded-lg text-sm px-4 py-2"
            :class="themeClasses.link"
            :active-class="themeClasses.active"
          >
            <component :is="item.icon" class="w-5 h-5 text-current" />
            <span v-if="!isCollapsed">{{ item.label }}</span>
          </RouterLink>
        </div>
      </div>
    </nav>
<!-- Profil utilisateur -->
<div v-if="!isCollapsed" class="px-4 py-3 border-t border-gray-200 bg-gray-50">
  <div class="flex items-center gap-3">
    <img
      :src="user.photo || 'https://ui-avatars.com/api/?name=' + user.nom + '+' + user.prenom"
      alt="Photo de profil"
      class="w-12 h-12 rounded-full object-cover shadow-sm border border-gray-200"
    />
    <div>
      <p class="text-sm font-semibold text-gray-800 leading-tight">
        {{ user.prenom }} {{ user.nom }}
      </p>
      <p class="text-xs text-gray-500 truncate max-w-[140px]">
        {{ user.email }}
      </p>
    </div>
  </div>
</div>

<!-- Déconnexion -->
<div :class="themeClasses.header" class="p-4 space-y-3 border-t border-gray-200">
  <button
    @click="logout"
    class="w-full flex items-center justify-center gap-2 px-4 py-2 rounded-lg transition font-medium shadow-sm"
    :class="themeClasses.logout"
  >
    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 11-4 0v-1m0-10V5a2 2 0 114 0v1" />
    </svg>
    <span v-if="!isCollapsed">Déconnexion</span>
  </button>

  <RouterLink
    v-if="!isCollapsed"
    to="/legal"
    class="block text-xs text-center mt-2 italic text-gray-400 hover:text-gray-500"
  >
    © DATAFUSE 2025
  </RouterLink>
</div>
        </div>
      </aside>
    </transition>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";
import DashboardIcon from "./Icons/DashboardIcon.vue";
import UserIcon from "./Icons/UserIcon.vue";
import FolderIcon from "./Icons/FolderIcon.vue";
import FileIcon from "./Icons/FileIcon.vue";
import BullhornIcon from "./Icons/BullhornIcon.vue";
import GearIcon from "./Icons/GearIcon.vue";
import EnvelopeIcon from "./Icons/EnvelopeIcon.vue";
import TicketIcon from "./Icons/TicketIcon.vue";

export default {
  components: { 
    RouterLink, 
    DashboardIcon, 
    UserIcon, 
    FolderIcon, 
    FileIcon, 
    BullhornIcon, 
    GearIcon, 
    EnvelopeIcon, 
    TicketIcon 
  },
  data() {
    return {
      isDrawerOpen: false,
      notifCount: 3,
      user: JSON.parse(localStorage.getItem("client")) || {
        prenom: "Invité",
        nom: "",
        email: "",
        photo: null,
      },
      // Menus
      generalMenu: [
        { label: "Dashboard", to: "/", icon: DashboardIcon },
        { label: "Projets", to: "/projects", icon: FolderIcon },
        { label: "Devis", to: "/billing", icon: FileIcon },
        { label: "Facture", to: "/factures", icon: FileIcon },
   
      ],
      commMenu: [
        { label: "Messages", to: "/messages", icon: EnvelopeIcon },
        { label: "Tickets", to: "/tickets", icon: TicketIcon },
      ],
      settingsMenu: [
        { label: "Paramètres", to: "/settings", icon: GearIcon }
      ],
    };
  },
  computed: {
    themeClasses() {
      return {
        bg: "bg-white",
        text: "text-[#64748B]",
        header: "border-gray-200",
        link: "hover:bg-[#EEF2FF] hover:text-[#4F46E5] text-[#64748B]",
        active: "bg-[#EEF2FF] text-[#4F46E5] font-medium",
        logout: "bg-red-600 hover:bg-red-700 text-white",
        footer: "text-gray-400 hover:text-gray-200",
      };
    },
  },
  methods: {
    toggleDrawer() {
      this.isDrawerOpen = !this.isDrawerOpen;
    },
  },
};
</script>

<style>
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from {
  transform: translateX(-100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
